import React from "react";
import AssetInputOrUploadSection from "./AssetInputOrUploadSection";
import BaseCreativeControls from "./BaseCreativeControls";
import { CREATIVE_NAMES, LEADERBOARD_PARALLAX_CONFIG_AD_FIELDS } from "./definitions";
import InputTextSection from "./InputTextSection";
import InputSwitchSection from "./InputSwitchSection";

const CREATIVE_TYPE = CREATIVE_NAMES.LEADERBOARD_PARALLAX;

export default function LeaderboardParallax({
    banner,
    clickTag,
    handleChange,
    impressionTag,
    currentCustomer,
    adServingType,
    zindex,
    topOffset,
    showDismissButton
}) {
    return (
        <>
            <BaseCreativeControls
                adServingType={adServingType}
                changeHandler={handleChange}
                clickTag={clickTag}
                impressionTag={impressionTag}
                creativeType={CREATIVE_TYPE}
            >
                <AssetInputOrUploadSection
                    inputValue={banner}
                    inputLabel="Banner (1600x400)"
                    inputName={LEADERBOARD_PARALLAX_CONFIG_AD_FIELDS.banner}
                    inputChangeHandler={handleChange}
                    inputAdtype={CREATIVE_TYPE}
                    isRequired={true}
                    currentCustomer={currentCustomer}
                    accept="image/*"
                    defaultExtension="jpeg"
                />
                <InputSwitchSection
                    label="Show close button"
                    isChecked={showDismissButton}
                    switchName={LEADERBOARD_PARALLAX_CONFIG_AD_FIELDS.showDismissButton}
                    changeHandler={handleChange}
                    creativeType={CREATIVE_TYPE}
                />
                <InputTextSection
                    label="zindex (integer)"
                    name={LEADERBOARD_PARALLAX_CONFIG_AD_FIELDS.zindex}
                    value={zindex}
                    changeHandler={handleChange}
                    adtype={CREATIVE_TYPE}
                    required={false}
                    isNumericInput={true}
                />
                <InputTextSection
                    label="Top offset (integer or float)"
                    name={LEADERBOARD_PARALLAX_CONFIG_AD_FIELDS.topOffset}
                    value={topOffset}
                    changeHandler={handleChange}
                    adtype={CREATIVE_TYPE}
                    required={false}
                    isNumericInput={true}
                />
            </BaseCreativeControls>
        </>
    );
}
